import { Button } from 'react-bootstrap';
import noItems from '../../../assets/images/icons/room.svg';
import URI from 'legacy/defaults/RoutesDefault';
import { Link, LinkProps } from 'react-router-dom';

type TCustomBootstrapLinkType = React.ComponentClass<LinkProps> &
	keyof JSX.IntrinsicElements;

export const EmptyProjectListState = () => (
	<div className="row justify-content-center text-center py-5">
		<div className="col-md-3">
			<img src={noItems} className="mw-100 mb-4" alt="" />
			<h6>Create your first project</h6>
			<p>
				This is where you will organize your specifications, proposals and
				purchase orders.
			</p>
			<Button
				as={Link as unknown as TCustomBootstrapLinkType}
				to={URI.project.add}
				variant="primary"
				size={'md' as any}
				className="btn-icon mt-4"
			>
				<i className="ri-add-line ri-lg"></i> Add Project
			</Button>
		</div>
	</div>
);
EmptyProjectListState.displayName = 'EmptyProjectListState';
